"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateFaqResponse = exports.GetFaqResponse = void 0;
class GetFaqResponse {
}
exports.GetFaqResponse = GetFaqResponse;
class CreateFaqResponse {
}
exports.CreateFaqResponse = CreateFaqResponse;
//# sourceMappingURL=faq.js.map